import { FaqBody } from '@/types/faq';
import { axiosErrorHandler, encodeParam, TEXTS, URLs } from '@/utils';
import axiosGdt from '@/utils/axiosGdt';

export const submitFaqForm = axiosErrorHandler(
  async (value: FaqBody, action: string, captchaResponse: string) => {
    const url = `${URLs.FAQ_SUBMIT}${action}&response=${encodeParam(
      captchaResponse || 'DEVELOPNNNNO'
    )}`;
    const response = await axiosGdt.post<any>(url, value, {
      headers: {
        'Content-Type': 'multipart/form-data; charset=UTF-8',
      },
    });
    return response.data;
  },
  TEXTS.defaultError
);
